import { useMemo } from "react";
import ISaleComp from "../interfaces/ISaleComp";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";

export default function (saleComps: ISaleComp[], shape: Shape | Shape[] | null): ISaleComp[] {
    const geometryService = useMemo(() => new GeometryService(), []);

    return useMemo(() => shape ? saleComps.filter(sc => geometryService.isPointInsideShape(sc.centerPoint, shape)) : saleComps, [saleComps, shape]);
}